export default __webpack_public_path__ + "static/media/invitation-bg1.f50e4cce.gif";